
<div class="container" id="voucher" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%;">
        <!--Header-->
        <div class="col-md-12 col-sm-12 col-xs-12"> 
            <div class="col-md-12" style="text-align: center;margin-top: 20px;">
                <span style="font-size: 20px">{{AgencyName}}</span><br>
                <span style="font-size: 13px;">{{City ? City + ',' : ''}} {{State}}</span><br>   
                <span style="font-size: 18px; font-weight: bold;">{{ledgername}}</span><br>   
                <span style="font-size: 20px;">Statement of Accounts</span><br>  
                <span style="font-size: 12px;"> {{fromDate | date: 'dd-MMM-yy'}} to {{toDate | date: 'dd-MMM-yy'}} </span><br> 
            </div>
        </div>
            <!--Table + Webview-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                <table class="table table-bordered ng-table {{(showColumn.narration || showColumn.cmnNotes) ? 'fs14 show-notes' : ''}}">
                    <thead>
                        <tr style="text-align: left;">
                            <th>Date</th>
                            <th>Voucher No.</th>
                            <th>Ledger</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Balance</th>
                            <th *ngIf="showColumn.narration">Narration</th>
                            <th *ngIf="showColumn.cmnNotes">Common Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!--List-->
                        <tr *ngFor="let v of voucher;">
                            <!--Date-->
                            <td>
                                <span class="no-line-break">{{v.EffectiveDate | date: "dd-MMM-yy"}}</span>
                            </td>
                            <!-- Voucher No.-->
                            <td>
                                <span class="no-line-break">{{v.VoucherNum}}</span>                           
                            </td>
                            <!-- Ledger -->
                            <td>
                                <span>{{v.MainLedger}}</span>
                            </td>
                            <!--Debit -->
                            <td style="text-align: right;">
                                <span class="no-line-break">{{v.DbAmt | lacFormat}}</span>
                            </td>
                            <!--Credit-->
                            <td  style="text-align: right;">
                                <span class="no-line-break">{{v.CrAmt | lacFormat}}</span>
                            </td>
                            <!--Balance-->
                             <td  style="text-align: right;">
                                <span class="no-line-break">{{v.newCloBal | cRDB}}</span>
                            </td>
                            <!-- Common Notes -->
                            <td *ngIf="showColumn.narration" style="text-align: left;">
                                <span>{{v.Notes ? v.Notes : '-'}}</span>
                            </td>
                            <!-- Narration -->
                            <td *ngIf="showColumn.cmnNotes" style="text-align: left;">
                                <span>{{v.CommonNotes ? v.CommonNotes : '-'}}</span>
                            </td>
                        </tr>

                        <!-- Grand Total Row -->
                        <tr style="font-weight: bold; background-color: #f8f8f8; border-top: 1px solid #333;">
                            <td style="text-align: left; font-weight: bold;">Grand Total</td>
                            <td></td>
                            <td></td>
                            <td style="text-align: right; font-weight: bold;">{{totalAmtDebit | lacFormat}}</td>
                            <td style="text-align: right; font-weight: bold;">{{totalAmtCredit | lacFormat}}</td>
                            <td style="text-align: right;"></td>
                            <td *ngIf="showColumn.narration"></td>
                            <td *ngIf="showColumn.cmnNotes"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
  </div>